module.exports = __webpack_public_path__ + "static/media/map-marker.5b15d7f0.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/map-marker.svg
// module id = 739
// module chunks = 0